import { debounce } from 'lodash';
import React from 'react';
import { SortingRule } from '@components/table';
import { userSearchDebounce } from '../../components/hooks/use-search';
import { useWrapRequest } from 'use-wrap-request';
import { useSearchReducer } from '../../components/hooks/useSearchReducer';
import { Api } from '../../core/api';
import { injectTSDI } from '../../core/tsdi';

export function useWorkoutValidationRulesStore() {
    const { fitnessActivityClient } = injectTSDI(Api);

    const [sorting, setSorting] = React.useState<
        SortingRule | SortingRule[] | undefined
    >(undefined);

    React.useEffect(() => {
        if (sorting) {
            dispatch({ type: 'sort', sort: sorting });
        }
    }, [sorting]);

    const [searchParams, dispatch] = React.useReducer(useSearchReducer, {
        size: 100,
        page: 0
    });
    const { setSearchTerm } = userSearchDebounce(dispatch);

    const workoutTypeRules = useWrapRequest(
        async (searchParams?: QueryParamsDto) => {
            const query = {
                page: searchParams?.page || 0,
                size: searchParams?.size || 100,
                search: searchParams?.search,
                sort: searchParams?.sort
            };

            const result =
                await fitnessActivityClient.admin.workoutTypeRuleControllerGetPage(
                    query,
                    {}
                );

            return {
                ...result.data,
                content: result.data.content || []
            };
        },
        {
            defaultData: {
                content: [],
                totalElements: 0,
                number: 0,
                size: 100,
                totalPages: 0
            }
        }
    );

    const debouncedAPICall = React.useCallback(
        debounce((searchParams?: QueryParamsDto) => {
            workoutTypeRules.request([searchParams]);
        }, 100),
        [workoutTypeRules]
    );

    React.useEffect(() => {
        debouncedAPICall(searchParams);
    }, [searchParams, debouncedAPICall]);

    return {
        workoutTypeRules,
        searchParams,
        sorting,
        setSorting,
        setSearchTerm,
        dispatch
    };
}
